import type { ListBuilderList } from '../../../types';
import { createStandardOrderClientEmbeddedColumns } from '../columns';
import { ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS } from '../shared';

/**
 * Client Embedded Requires Attention list configuration
 * Orders from CRM or E-Commerce that need attention (embedded in client view)
 */
export const clientEmbeddedRequiresAttentionList: ListBuilderList = {
	id: 'client-embedded-requires-attention',
	cacheTTL: 600000,
	name: 'Requires Attention',
	type: 'default',
	active: true,
	sortOrder: 3,
	requiredFeature: 'order-entry',
	columns: createStandardOrderClientEmbeddedColumns(),
	description:
		"Orders from CRM or E-Commerce that need attention: orders with 'Held' or 'Approval Required' status, OR orders with alert errors that are still in a status someone can act on",
	defaultSortId: 'column-dates-desc',
	requiredFields: ORDER_CLIENT_EMBEDDED_REQUIRED_FIELDS,
	filterRules: {
		orderOrigin: {
			defaultValue: [
				{ id: '1', label: 'CRM' },
				{ id: '3', label: 'E-Commerce' },
			],
		},
		orderStatus: {
			defaultValue: [
				{
					id: 'requires-attention',
					data: {
						id: 'requires-attention',
						label: 'Requires Attention',
					},
					label: 'Requires Attention',
				},
			],
		},
	},
};
